import React from 'react';
import { InputText } from 'design-system/Form';

// can't use mongoose method since we're on the frontend
export function isValidObjectId(objectId: string): boolean {
  return /^[0-9A-Fa-f]{24}$/g.test(objectId);
}

export function isValidEmail(email: string): boolean {
  return /\S+@\S+\.\S+/g.test(email);
}

interface IObjectIdInputProps {
  initialInput?: string;
  onValidEntry?(objectIds: string[]): void;
  onEntry?(objectIds: string[] | undefined): void;
  labelPrompt?: string;
  hideLabelPrompt?: boolean;
  placeholder?: string;
  stopPropagation?: boolean;
  onBlur?(): void;
  singleObjectId?: boolean;
  preventDuplicates?: boolean;
  value?: string;
  allowEmails?: boolean;
}

interface IObjectIdInputState {
  currentInput: string;
  isValid: boolean;
}

/** TODO refactor to use `design-system/TextInput` */
class ObjectIdInput extends React.Component<IObjectIdInputProps, IObjectIdInputState> {
  constructor(props: IObjectIdInputProps) {
    super(props);
    const initialInput = props.initialInput || '';
    this.state = {
      currentInput: initialInput,
      isValid: this.getObjectIds(initialInput) !== undefined,
    };
  }

  getObjectIds(currentInput: $FIXME) {
    if (currentInput === undefined) {
      return currentInput;
    }
    const objectIds = currentInput
      .trim()
      .split(/[,\s]+/g)
      .map((el: $FIXME) => el.trim())
      .filter((el: $FIXME) => el !== '');

    if (this.props.singleObjectId && objectIds.length > 1) {
      return undefined;
    }

    if (this.props.preventDuplicates && new Set(objectIds).size !== objectIds.length) {
      return undefined;
    }

    return objectIds.every(
      (objectId: $FIXME) =>
        isValidObjectId(objectId) || (this.props.allowEmails && isValidEmail(objectId)),
    )
      ? objectIds
      : undefined;
  }

  onChange(e: $FIXME) {
    const currentInput = e.target.value;
    const objectIdArray = this.getObjectIds(currentInput);
    const isValid = objectIdArray !== undefined;
    this.setState({
      currentInput,
      isValid,
    });

    if (isValid && this.props.onValidEntry) {
      // @ts-ignore FIXME - Typescript Strict [2722]
      this.props.onValidEntry(objectIdArray);
    }

    if (this.props.onEntry) {
      this.props.onEntry(objectIdArray);
    }

    if (this.props.stopPropagation) {
      e.stopPropagation();
    }
  }

  render() {
    return (
      <div>
        {this.props.hideLabelPrompt !== true && (
          <strong>{this.props.labelPrompt || 'Object IDs'}</strong>
        )}
        <InputText
          defaultValue={this.props.initialInput}
          onChange={this.onChange.bind(this)}
          invalid={!this.state.isValid}
          placeholder={
            this.props.placeholder ||
            `Object ID${this.props.singleObjectId ? '' : 's (comma or space separated)'}`
          }
          onKeyDown={(e: $FIXME) => {
            if (this.props.stopPropagation) {
              e.stopPropagation();
            }
          }}
          onBlur={this.props.onBlur || (() => {})}
          value={this.props.value}
        />
      </div>
    );
  }
}

export default ObjectIdInput;
